<script>
export default {
  name: "DidoChip",
};
</script>

<script setup>
import { inject, computed } from "vue";

// define Props
const props = defineProps({
  item: { type: Object, required: true },
  type: { type: String, required: true },
  fromDatasetOrDatafile: { type: String, required: true },
  size: { type: String, required: false, default: "sm" },
  bgColor: { type: String, required: false, default: "secondary" },
  textColor: { type: String, required: false, default: "white" },
  outline: { type: Boolean, required: false, default: false },
  icon: { type: String, required: false, default: null },
});

// define events emitted
const emit = defineEmits(["label-selection"]);

// inject variables for interaction with catalog
const catalogUrl = inject("catalogUrl", () => null);
const inCatalog = inject("inCatalog", null);

// computed datas
const labelFromDatasetOrDatafile = computed(() => {
  if (props.fromDatasetOrDatafile === "dataset") return "les jeux de données";
  if (props.fromDatasetOrDatafile === "datafile")
    return "les fichiers de données";
  return "";
});
const labelFromType = computed(() => {
  if (props.type === "tag") return "le mot-clé";
  if (props.type === "topic") return "le thème";
  if (props.type === "license") return "la licence de publication";
  if (props.type === "granularity") return "la granularité";
  if (props.type === "frequency") return "la fréquence d'actualisation";
  if (props.type === "zone") return "la zone";
  return "";
});
</script>

<template>
  <QChip
    :key="item.id"
    :size="props.size"
    :color="props.bgColor"
    :text-color="props.textColor"
    :outline="props.outline"
    v-bind="props.icon && { icon: props.icon }"
    :class="[
      inCatalog ? 'cursor-pointer' : 'cursor-inherit',
      'dido-chip-metadata-facets',
    ]"
    clickable
  >
    <template #default>
      <a
        v-if="inCatalog"
        :href="
          catalogUrl({
            type: props.type,
            value: item.id,
            card: props.fromDatasetOrDatafile,
          })
        "
        :title="`Explorer ${labelFromDatasetOrDatafile} contenant ${labelFromType} ${item.display}`"
        @click.prevent.stop="
          emit('label-selection', { type: props.type, value: item.id })
        "
      >
        {{ item.display }}
      </a>
      <span v-else>{{ item.display }}</span>
    </template>
  </QChip>
</template>
